import {
  ResetFormData,
  ResetFormErrors,
  ResetFormTouched,
} from "../../Components/common/types";

export function handleResetBlur<T extends Partial<ResetFormTouched>>(
  name: keyof ResetFormData,
  value: string | number,
  touched: T,
  setTouched: React.Dispatch<React.SetStateAction<T>>,
  resetValidateFieldWrapper: (
    name: keyof ResetFormData,
    value: string | number
  ) => void
) {
  console.log("Touch state handleBlur", touched);
  setTouched({
    ...touched,
    [name]: true,
  });
  // console.log("handleBlur:", name, "value:", value);
  resetValidateFieldWrapper(name, value);
}

//validate field on focus and then blur if left empty
export function resetValidateField<T extends Partial<ResetFormErrors>>(
  name: keyof ResetFormData,
  value: string | number,
  errors: T,
  setErrors: React.Dispatch<React.SetStateAction<T>>,
  resetFormData: Partial<ResetFormData>
) {
  // console.log('regValidateField - name:', name, 'value:', value);
  const newErrors = { ...errors }; //collect all errors and show them at ones

  switch (name) {
    case "otp":
      if (!value) {
        newErrors.otp = "Enter the code sent to your email.";
      } else {
        const codeStr = String(value);
        if (!/^\d{6}$/.test(codeStr)) {
          newErrors.otp = "Only 6 digits required.";
        } else {
          newErrors.otp = ""; // Clear error if valid
        }
      }
      break;
    case "email":
      if (typeof value === "string") {
        if (!value) {
          newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(value)) {
          newErrors.email = `${name} address is invalid`;
        } else {
          newErrors.email = "";
        }
      }
      break;
    case "newPassword":
      if (!value) {
        newErrors.newPassword = "New Password is required.";
      } else if (
        typeof value === "string" &&
        !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[A-Za-z\d\W_]{8,}$/.test(value)
      ) {
        newErrors.newPassword =
          "Password must be at least 8 characters long, include an uppercase letter, a lowercase letter, and a number.";
      } else {
        newErrors.newPassword = ""; // Clear error if valid
      }

      // 🔹 Revalidate confirmPassword when newPassword changes
      if (
        resetFormData.confirmPassword &&
        resetFormData.confirmPassword !== value
      ) {
        newErrors.confirmPassword = "Password does not match";
      } else {
        newErrors.confirmPassword = ""; // Clear error if they match
      }
      break;
    case "confirmPassword":
      if (!value) {
        newErrors.confirmPassword = "You need to confirm your password";
      } else if (resetFormData.newPassword !== value) {
        newErrors.confirmPassword = "Password does not match";
      } else {
        newErrors.confirmPassword = ""; // Clear error if valid
      }
      break;
    default:
      break;
  }

  setErrors(newErrors);
  // console.log('regValidateField - errors:', newErrors);
}

//validate on empty field submission
export function resetValidate<T extends Partial<ResetFormData>>(
  resetFormData: T,
  errors: Partial<ResetFormErrors>,
  setErrors: React.Dispatch<React.SetStateAction<Partial<ResetFormErrors>>>,
  setTouched: React.Dispatch<React.SetStateAction<Partial<ResetFormTouched>>>
): boolean {
  // console.log('validate - resetFormData:', resetFormData);
  let formIsValid = true;

  (Object.keys(resetFormData) as (keyof ResetFormData)[]).forEach((key) => {
    const value = resetFormData[key];
    //check if value exists and validate it
    if (value !== undefined) {
      resetValidateField(key, value, errors, setErrors, resetFormData);
    }

    // Check if the field is submitted empty or undefined
    if (!value) {
      formIsValid = false;
      errors[key] = `${
        (key as string).charAt(0).toUpperCase() + (key as string).slice(1)
      } is required`; //a case of empty fields submitted
    }
  });

  setErrors(errors); //a case of empty fields submitted

  // Mark all fields as touched
  setTouched({
    otp: true,
    newPassword: true,
    confirmPassword: true,
  });

  return formIsValid;
}
